export default "__VITE_ASSET__4bae891e__"